import { createSvgIcon } from '@mui/material';

export const AuthProviderRounded = createSvgIcon(
  <svg xmlns='http://www.w3.org/2000/svg' height='24px' viewBox='0 -960 960 960' width='24px'>
    <path
      fill='currentcolor'
      d='M438-178q20 12 42 11.5t42-12.5l182-111q-50-35-107-52.5T480-360q-60 0-117.5 17.5T254-291l184 113Zm42-262q58 0 99-41t41-99q0-58-41-99t-99-41q-58 0-99 41t-41 99q0 58 41 99t99 41ZM438-85 158-257q-18-11-28-29t-10-39v-310q0-21 10-39t28-29l280-172q20-12 42-12t42 12l280 172q18 11 28 29t10 39v310q0 21-10 39t-28 29L522-85q-20 12-42 12t-42-12Z'
    />
  </svg>,
  'AuthProviderRounded'
);
